
/* eslint-disable import/no-extraneous-dependencies, import/prefer-default-export */
import { writable } from "svelte/store";
export const reportDetailStore = writable({});


